<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.91815 4.97612C7.49077 3.85624 8.65585 3.0896 10 3.0896C11.3441 3.0896 12.5092 3.85624 13.0818 4.97613C13.2298 5.26542 13.5124 5.47075 13.8333 5.52204C15.0753 5.72057 16.1644 6.59172 16.5798 7.87008C16.9951 9.14845 16.626 10.4934 15.738 11.3841C15.5085 11.6142 15.4005 11.9464 15.4509 12.2673C15.6459 13.5099 15.1539 14.815 14.0665 15.6051C12.9791 16.3951 11.5859 16.4597 10.4644 15.8903C10.1747 15.7432 9.82533 15.7432 9.5356 15.8903C8.41411 16.4597 7.02092 16.3951 5.93349 15.6051C4.84604 14.815 4.3541 13.5099 4.54909 12.2673C4.59946 11.9463 4.49151 11.6142 4.26209 11.3841C3.37397 10.4934 3.00488 9.14845 3.42023 7.87008C3.8356 6.59172 4.92475 5.72057 6.16677 5.52204C6.48762 5.47075 6.77023 5.26542 6.91815 4.97612Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'BrandWorkIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
